<template>
    <div class="d-flex observador-wrapper">
        <div class="d-flex align-center observador">
            <span class="observador-label">{{ label }}</span>
            <v-tooltip top>
                <template v-slot:activator="{ on }">
                    <span v-on="on" class="definir-ordem-tooltip">
                        <v-icon size="13px">mdi-information</v-icon>
                    </span>
                </template>
                <span>{{ informacao }}</span>
            </v-tooltip>
        </div>

        <v-switch
            class="ma-0 pa-0"
            color="primary"
            dense
            hide-details
            v-model="value.observador"
            :disabled="desabilitarCampo"
        />
    </div>

</template>

<script>
export default {
    name: 'SwitchObservador',
    props: {
        value: {
            required: true
        },
        desabilitarCampo: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            required: true
        },
        informacao: {
            type: String,
            required: true
        }
    }
}
</script>

<style lang="stylus" scoped>
.observador-wrapper
    justify-content space-between

    .observador
        gap 5px

        .observador-label
            color var(--text-color-300)
            font-size 16px
</style>
